import { createSlice } from "@reduxjs/toolkit";

const biltySlice = createSlice({
  name: "biltySlice",
  initialState: {
    bilty: [],
    status: "ok",
  },
  reducers: {
    setBiltyDetail: (state, action) => {
      state.bilty = action.payload;
    },
    editBiltyDetail: (state, action) => {
      const { id, updatedBiltyDetail } = action.payload;
      const index = state.bilty.findIndex((bilty) => bilty.id === id);
      if (index !== -1) {
        state.bilty[index] = {
          ...state.bilty[index],
          ...updatedBiltyDetail,
        };
      }
    },
    validateBiltyDetail: (state, action) => {
      return;
    },
  },
});

export const { setBiltyDetail, editBiltyDetail, validateBiltyDetail } =
  biltySlice.actions;
export default biltySlice.reducer;
